import { IonIcon, IonLabel, IonChip } from '@ionic/react'
import { useStore, useStoreMap } from 'effector-react'
import { bulb } from 'ionicons/icons'
import { DriverStatusEnum } from '~/shared/config/enums'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { $driver } from '../../model'
import { UploadDocumentsDrawer } from '../UploadDocumentsDrawer'
import {
  $isRetryChecksDrawerOpen,
  openRetryChecksDrawer,
  closeRetryChecksDrawer,
  retryChecks,
  retryChecksFx,
} from './model'
import { Title } from './styled'

export function RetryChecks() {
  const status = useStoreMap($driver, (driver) => driver?.getStatus())
  const retryChecksPending = useStore(retryChecksFx.pending)
  const isRetryChecksDrawerOpen = useStore($isRetryChecksDrawerOpen)

  const handleRetryChecks = () => {
    retryChecks()
  }

  if (status !== DriverStatusEnum.CHECKS_EXPIRED) {
    return
  }

  return (
    <>
      <Button fullWidth onClick={() => openRetryChecksDrawer()}>
        Запросить проверки
      </Button>
      <DrawerComponent
        isShow={isRetryChecksDrawerOpen}
        onCancel={closeRetryChecksDrawer}
      >
        <Title>Запросить повторные проверки ?</Title>

        <IonChip color='secondary' style={{ marginBottom: '16px' }}>
          <IonIcon icon={bulb}></IonIcon>
          <IonLabel>
            Проверка может занять до 30 минут.
            <br />
            После прохождения повторных проверок вы сможете арендовать
            автомобиль
          </IonLabel>
        </IonChip>

        <Button
          size='large'
          fullWidth
          loading={retryChecksPending}
          onClick={handleRetryChecks}
        >
          Запросить проверки
        </Button>
      </DrawerComponent>

      <UploadDocumentsDrawer />
    </>
  )
}
